export const LOGIN_OK = 'LOGIN_OK';
export const LOGIN_NONE = "LOGIN_NONE";
